var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadIconBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.849,
    height: 16,
    viewBox: "0 0 17.849 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29291",
    "data-name": "Group 29291",
    transform: "translate(-760.576 -308.146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11275",
    "data-name": "Path 11275",
    d: "M9.867,13.2a.444.444,0,0,1-.349-.186l-3.384-4.4C5.841,8.234,6.058,7.6,6.483,7.6H8.256V3a.92.92,0,0,1,.806-1h1.611a.92.92,0,0,1,.806,1V7.6h1.773c.425,0,.643.634.349,1.014l-3.384,4.4A.444.444,0,0,1,9.867,13.2Z",
    transform: "translate(759.854 306.146)",
    fill: "#0074b0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11276",
    "data-name": "Path 11276",
    d: "M16.547,20.718H1.3A1.25,1.25,0,0,1,0,19.529v-.34A1.25,1.25,0,0,1,1.3,18H16.547a1.25,1.25,0,0,1,1.3,1.189v.34A1.25,1.25,0,0,1,16.547,20.718Z",
    transform: "translate(760.576 303.429)",
    fill: "#0074b0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIconBlue);
export default __webpack_public_path__ + "static/media/download-icon-blue.3e86cfa6c62a9f5c9bf3f908d159f2ac.svg";
export { ForwardRef as ReactComponent };